import InnerBannerBreadcrumb from "../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import { useGetProtectedApiDataQuery } from "../../redux/services/apiSlice";
import { useSelector } from "react-redux";
import PageLastUpdated from "../../components/shared/PageLastUpdated";
import { useParams } from "react-router-dom";
import Loader from "../../components/Loader";

const MissionVisionPage = () => {
  const { id } = useParams();
  const { languageType } = useSelector((state) => state.homeSlice);

  const {
    data: visionAndMissionData = [],
    isLoading: visionAndMissionIsLoading,
  } = useGetProtectedApiDataQuery({
    url: "vision_mission",
    lang: languageType,
  });

  const fileredVisionData = visionAndMissionData.find(
    (item) => item.nid === id,
  );

  const formatDateToDDMMYYYY = (dateStr) => {
    if (!dateStr) return ""; // handle null/undefined
    const [y, m, d] = dateStr.split("-") || [];
    return y && m && d ? `${d}-${m}-${y}` : "";
  };

  if (visionAndMissionIsLoading) {
    return <Loader />;
  }

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage="/images/inner_aboutbann.jpg"
        title={fileredVisionData?.title}
        titleLink="/mission-vision"
        levelTwo={false}
        levelThree={false}
        isActive={fileredVisionData?.title}
      />

      <div className="inner-container">
        <div className="container about_inntxt">
          <div className="container">
            <PageLastUpdated
              lastUpdatedOn={formatDateToDDMMYYYY(fileredVisionData?.changed)}
            />
            <div className="power-section">
              <div className="row">
                <div className="col-12 col-sm-12 col-md-12 col-lg-12 mvDescWrap">
                  <div className="title-sec">
                    <h4 className="title-sec">{fileredVisionData?.title}</h4>
                    <div
                      className="vision-text"
                      dangerouslySetInnerHTML={{
                        __html:
                          fileredVisionData?.field_front_text_of_vision_missi ||
                          "",
                      }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default MissionVisionPage;
